import constants from 'constants/index'

const { STATUSES, CLIENT_TYPE } = constants.preRegistration

const mountReal = (data, parentContractId = null) => {
  const {
    country,
    state,
    city,
    neighborhood,
    street,
    number,
    postalCode,
    complement,
    sellerId,
    fantasyName,
    document,
    email,
    phone,
    planId,
    name,
    kind,
    type,
    responsibleEmail,
    responsibleName,
    responsiblePhone,
    typeClient,
    typeService,
    vertical,
    companyTemplate,
    beneficiarySebrae,
  } = data

  const responsibleUser = {
    email: responsibleEmail.toLowerCase(),
    name: responsibleName,
    phone: responsiblePhone.replace(/\D/g, ''),
  }

  return {
    name: name || fantasyName,
    fantasyName,
    document,
    email,
    phone,
    planId,
    sellerId,
    responsibleUser,
    kind,
    address: {
      postalCode: postalCode.replace(/\D/g, ''),
      country,
      state: state.toUpperCase(),
      city,
      neighborhood,
      street,
      number,
      complement,
    },
    type,
    parentContractId,
    typeClient,
    typeService,
    vertical,
    companyTemplateId: companyTemplate?.id,
    status:
      typeClient === CLIENT_TYPE
        ? STATUSES.INITIATED_STATUS
        : STATUSES.FINALIZED_STATUS,
    beneficiarySebrae,
  }
}

export default mountReal
